import React from 'react';
import MarkAsPaidExpenseButton, {
  MarkAsPaidExpenseButtonProps,
} from 'domain/finance/expenses/shared/button/MarkAsPaidExpenseButton';
import { useListContext } from 'framework/list';

const MarkAsPaidExpenseListButton = (props: MarkAsPaidExpenseButtonProps) => {
  const { reloadData } = useListContext();

  return <MarkAsPaidExpenseButton {...props} onSubmit={reloadData} />;
};

export default MarkAsPaidExpenseListButton;
